import SpriteSymbol from "../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chat--filled",
  "use": "chat--filled-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"chat--filled\">\n<path d=\"M2 5.10345C2 3.38946 3.34315 2 5 2H19C20.6569 2 22 3.38946 22 5.10345V15.4483C22 17.1623 20.6569 18.5517 19 18.5517H16.5C15.5557 18.5517 14.6666 19.0116 14.1 19.7931L12.8 21.5862C12.4 22.1379 11.6 22.1379 11.2 21.5862L9.9 19.7931C9.33344 19.0116 8.44427 18.5517 7.5 18.5517H5C3.34315 18.5517 2 17.1623 2 15.4483V5.10345Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol